// one reusable "can't show this" card, reused for a few different 
// situations (unsupported file type, expired link, a crash) so 
// they all look
//  consistent instead of each having its own custom error screen.

import React from 'react';

interface UnsupportedNoticeProps {
  icon: string;
  title: string;
  description: string;
  onDownload?: () => void;
  onRetry?: () => void;
}

// One shared "can't show this inline" card, reused for: unrecognized file
// types, legacy .doc (routed here by DocxRenderer after sniffing the byte
// signature), a renderer crash (ErrorBoundary's fallback), and every
// classified load error (expired SAS / CORS / HTTP) — only the icon, copy,
// and which action buttons are present change per case.
const UnsupportedNotice: React.FC<UnsupportedNoticeProps> = ({ icon, title, description, onDownload, onRetry }) => (
  <div className="doc-preview-notice">
    <i className={icon} aria-hidden="true" />
    <p className="doc-preview-notice__title">{title}</p>
    <p className="doc-preview-notice__description">{description}</p>
    {(onDownload || onRetry) && (
      <div className="doc-preview-notice__actions">
        {onRetry && (
          <button type="button" className="doc-preview-btn" onClick={onRetry}>
            <i className="fas fa-rotate-right" aria-hidden="true" /> Retry
          </button>
        )}
        {onDownload && (
          <button type="button" className="doc-preview-btn" onClick={onDownload}>
            <i className="fas fa-download" aria-hidden="true" /> Download
          </button>
        )}
      </div>
    )}
  </div>
);

export default UnsupportedNotice;
